// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"ArrowIcon__arrowIcon___2u34v","tpb":"ArrowIcon__tpb___zFJDU","disabled":"ArrowIcon__disabled___3-vWI","left":"ArrowIcon__left___3nLcZ"};